export const onboardingOptions = {
  categories: [
    { value: 'dress' as const, label: '예복', icon: 'ri-shirt-line' },
    { value: 'jewelry' as const, label: '예물', icon: 'ri-vip-diamond-line' },
    { value: 'hanbok' as const, label: '한복', icon: 'ri-flower-line' },
  ],
  categoryStatuses: [
    { value: 'not_started', label: '아직 시작 전' },
    { value: 'browsing', label: '몇 군데 보는 중' },
    { value: 'has_candidate', label: '후보 있음' },
    { value: 'consultation', label: '상담 예약' },
    { value: 'contracted', label: '계약 완료' },
  ],
  concerns: [
    { value: 'price', label: '가격이 적당한지 모르겠어요' },
    { value: 'criteria', label: '기준을 모르겠어요' },
    { value: 'too_many', label: '업체가 너무 많아요' },
    { value: 'reviews', label: '실제 후기가 궁금해요' },
    { value: 'urgent', label: '빨리 정해야 해요' },
  ],
};